import { useTranslation, UploadButton } from '@testsigma/atoms';

const UploadFileButton = ({ onFileRemove, onFileSelect, uploadedFileName }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className='flex justify-between items-baseline'>
        <p className='text-secondary-500 font-semibold text-xs mt-5 mb-1'>
          {t('agent.upload_agent_log')} {'*'}
        </p>
        <a
          href='https://testsigma.com/docs/agent/troubleshooting/logs/'
          target='_blank'
          className='text-secondary-unique-200 text-xs'
          rel='noreferrer'>
          {t('agent.how_to_locate_agent_logs')}
        </a>
      </div>
      <UploadButton
        accept='.zip'
        label={
          <p className='font-normal text-sm text-primary-600 hover:text-primary-600 hover:underline'>
            {t('agent.attach_zip_file')}
          </p>
        }
        onFileRemove={onFileRemove}
        onFileSelect={onFileSelect}
        type='filled'
        uploadedFileName={uploadedFileName}
        className='w-full'
      />
    </>
  );
};

export default UploadFileButton;
